export default __webpack_public_path__ + "static/media/html-css.95fbc046.svg";